import './EventFileModal.scss';

export { default } from './EventFileModal';
